import React from "react";
import CustomStatusTask from "../components/CustomStatusTask";

function CompletedTaskPage() {
  return (
    <div>
      <CustomStatusTask StatusFilter="Completed" />
    </div>
  );
}

export default CompletedTaskPage;
